// === HAINSWORTH HOMEPAGE INTERACTIONS ===

// Header scroll effect
var header = document.getElementById('header');
if (header) {
  var lastScroll = 0;
  window.addEventListener('scroll', function() {
    var currentScroll = window.scrollY;
    if (currentScroll > 50) {
      header.style.background = 'rgba(10, 10, 15, 0.95)';
      header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.3)';
    } else {
      header.style.background = 'rgba(10, 10, 15, 0.85)';
      header.style.boxShadow = 'none';
    }
    lastScroll = currentScroll;
  });
}

// FAQ Accordion
document.querySelectorAll('.hw-faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
        var item = btn.parentElement;
        var isActive = item.classList.contains('active');
        document.querySelectorAll('.hw-faq-item').forEach(function(i) { i.classList.remove('active'); });
        if (!isActive) {
            item.classList.add('active');
        }
    });
});

// Email form - enhance UX but let Shopify handle submission
var emailForm = document.querySelector('.hw-email-form');
if (emailForm) {
    emailForm.addEventListener('submit', function(e) {
        var input = emailForm.querySelector('input');
        var btn = emailForm.querySelector('button');
        if (input && input.value && btn) {
            btn.textContent = 'Subscribing...';
            btn.style.opacity = '0.7';
        }
    });
}

// Add-to-cart feedback - let the form submit naturally
var cartCount = 0;
document.querySelectorAll('.hw-btn-add').forEach(function(btn) {
    btn.addEventListener('click', function() {
        var originalText = btn.textContent;
        var countEl = document.querySelector('.hw-cart-count');
        if (countEl) {
            cartCount++;
            countEl.textContent = cartCount;
        }
        setTimeout(function() {
            if (btn.textContent === originalText) {
                btn.textContent = 'Added!';
                setTimeout(function() { btn.textContent = originalText; }, 1500);
            }
        }, 100);
    });
});

// Countdown timer
function updateCountdown() {
    var countdownEl = document.querySelector('[id^="hw-countdown"]');
    if (!countdownEl) return;
    var daysEl = countdownEl.querySelector('.hw-days');
    var hoursEl = countdownEl.querySelector('.hw-hours');
    var minutesEl = countdownEl.querySelector('.hw-minutes');
    if (!daysEl || !hoursEl || !minutesEl) return;
    var days = parseInt(countdownEl.dataset.days || '2');
    var hours = parseInt(countdownEl.dataset.hours || '14');
    var minutes = parseInt(countdownEl.dataset.minutes || '37');
    var target = new Date();
    target.setDate(target.getDate() + days);
    target.setHours(target.getHours() + hours);
    target.setMinutes(target.getMinutes() + minutes);
    var now = new Date();
    var diff = target - now;
    if (diff > 0) {
        var d = Math.floor(diff / (1000 * 60 * 60 * 24));
        var h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        daysEl.textContent = String(d).padStart(2, '0');
        hoursEl.textContent = String(h).padStart(2, '0');
        minutesEl.textContent = String(m).padStart(2, '0');
    }
}
updateCountdown();
setInterval(updateCountdown, 60000);

// Reveal on scroll
var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, { threshold: 0.1 });
document.querySelectorAll('.hw-product-card, .hw-category-card, .hw-testimonial-card, .hw-faq-item').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
});
